import React from 'react';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';

class ProductTile extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            name,
            url,
            priceViewModel,
            image,
            onClick,
            description,
            formats,
            languages
        } = this.props;

        const imageUrl = image?.Url;

        return (
            <a href={url} title={name} onClick={onClick} className="d-block product-tile item-tile link-wrapper">
                <div className="product-tile-inner row">
                {imageUrl &&
                    <div className="col-12 col-lg-4 search-result-img px-0 px-md-2">
                        <img
                            src={imageUrl}
                            alt={image.Alt}
                            className="img-fluid"
                        />
                    </div>
                }
                    <div className="col-12 col-lg-8">
                        <h3 className="headline headline-xs">{name}</h3>
                        <span className="description" dangerouslySetInnerHTML={{__html: description}}>
                        </span>
                        <div className="p-format">
                            {formats &&
                                <div><i className="fa fa-check"></i> {translateResourceString("/SearchApp/ProductTile/Format")} {formats}</div>
                            }
                            {languages &&
                                <div><i className="fa fa-check"></i> {translateResourceString("/SearchApp/ProductTile/Language")} {languages}</div>
                            }
                        </div>
                    </div>
                </div>
            </a>);
    }
}


ProductTile.propTypes = {
    name: PropTypes.string,
    url: PropTypes.string,
    priceViewModel: PropTypes.shape({
        RegularPrice: PropTypes.number,
        SalePrice: PropTypes.number,
        IsSalePrice: PropTypes.bool
    }),
    image: PropTypes.shape({
        Url: PropTypes.string,
        Alt: PropTypes.string
    }),
    description: PropTypes.string,
    formats: PropTypes.string,
    languages: PropTypes.string
};

export default ProductTile;
